// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1iyZu","unreadBadge":"styles_unreadBadge__lQ3tX","modalContent":"styles_modalContent__AETGq","modal":"styles_modal__N5jPo"};